import React, { Component } from 'react'

export class Progress extends Component {
    render() {
        return (
                <div className="box">
                <div className="box-body">
                    <div className="box-header">
                        <h3 className="text-center">Progress</h3>
                    </div>
                    <div className="alert alert-danger" role="alert">
                        <h1>Schedule - B Total Amount <br/>
                            Work Order Amount 
                        </h1>
                    </div>
                    <div className="error-content">
                        <h3><i className="fa fa-exclamation-triangle text-warning"></i> schedule-B Not Done.</h3>
                        <p>
                            Please complete schedule-B before entering progress details
                        </p>
                    </div>
                    <div className="col-md-12">
                        <form action="partworksdetails/progressitemsave">
                            <div className="col-md-4">
                            <div className="form-group">
                                <label>Item Description</label> 
                                <select name="itemid" className="form-control">
                                    <option value="">Select Item</option>
                                </select>
                            </div>
                            </div>
                            <div className="col-md-3">
                            <div className="form-group">
                                <label>Date</label> 
                                <input type="text" name="progressdate" placeholder="DD-MM-YYYY" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-3">
                            <div className="form-group">
                                <label>Executed Quantity</label> 
                                <input type="text" name="exec_quantity" className="form-control" />
                            </div>
                            </div>
                            <div className="col-md-2" style={{ padding: '2.3%'}} >
                            <input type="submit" className="btn btn-primary" value="Save" />
                    </div>
                    </form>	
                    <div className="col-md-12 table-responsive">
                        <table className="table table-bordered">
                            <thead>
                            <tr>
                                <th>Sr.No.</th>
                                <th>Description</th>
                                <th>Unit</th>
                                <th>Quantity</th>
                                <th>Rate</th>
                                <th>Executed Quantity</th>
                                <th>Balance Quantity</th>
                            </tr>
                            </thead>
                        </table>
                    </div>
                    <div className="col-md-12">			
                        <a data-title='View Summary' className='view-pdf' title='Click Here'  href="partworks/progresslist"><strong> Click here to view  Progress History </strong></a>		
                    </div>
                </div>
                <h3 className="text-center">Extra Progress</h3>
                <div className="col-md-12">
                    <form action="partworksdetails/progressextraitemsave">
                        <div className="col-md-4">
                            <div className="form-group">
                            <label>Item Description</label> 
                            <select name="extra_itemid" className="form-control">
                                <option value="">Select Item</option>
                            </select>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                            <label>Date</label> 
                            <input type="text" name="extra_progressdate" placeholder="DD-MM-YYYY" className="form-control" />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                            <label>Executed Quantity</label> 
                            <input type="text" name="extra_exec_quantity" className="form-control" />
                            </div>
                        </div>
                        <div className="col-md-2" style={{padding: '2.3%'}}>
                        <input type="submit" className="btn btn-primary" value="Save" />
                </div>
                </form>	
                <div className="col-md-12 table-responsive">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                            <th>Sr.No.</th>
                            <th>Description</th>
                            <th>Unit</th>
                            <th>Quantity</th>
                            <th>Rate</th>
                            <th>Executed Quantity</th>
                            <th>Balance Quantity</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div className="col-md-12">			
                    <a data-title='View Summary' className='view-pdf' title='Click Here'  href="partworks/extraprogresslist"><strong> Click here to view  Progress History </strong></a>		
                </div>
                </div>
                <div className="col-md-12">
                <form action="partworksdetails/progressoverall_progress">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Overall Physical Progress(%)</label> 
                            <input type="text" min="0" max="100" name="overall_progress" className="form-control" />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Date</label> 
                            <input type="text" name="progress_date" placeholder="DD-MM-YYYY" className="form-control" />
                        </div>
                    </div>
                    <div className="col-md-4" style={{padding: '2.3%'}}>
                    <input type="submit" className="btn btn-primary" value="Save" />
                </div>
                </form>	
                </div>	
                <div className="col-md-12">
                <h3 className="text-center">Progress Change Request</h3>
                <form action="partworksdetails/progressoverall_progress_request" >
                    <div className="col-md-4">
                        <div className="form-group">
                            <label>Overall Physical Progress(%)</label> 
                            <input type="text" min="0" max="100" name="overall_progress" className="form-control" />
                        </div>
                    </div>
                    <div className="col-md-4" style={{ padding: '2.3%'}}>
                    <input type="submit" className="btn btn-primary" value="Save" />
                </div>
                </form>	
                <div className="col-md-12 table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Sr.No.</th>
                            <th>Physical Progress</th>
                            <th>Status</th>
                            <th>Requested By</th>
                            <th>Requested Date</th>
                            <th>Aproved By</th>
                            <th>Aproved Date</th>
                        </tr>
                    </thead>
                </table>
                </div>
                </div>
                </div>
                </div>
        )
    }
}

export default Progress
